// extracted by mini-css-extract-plugin
export default {"container":"Card_container__Us0lq","card":"Card_card__f0o1b","title":"Card_title__5PE4f","content":"Card_content__UW0yG","icon":"Card_icon__SqDMv"};